/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Write_RecipeInputs */

const en_import_write_recipe = /** @type {(inputs: Import_Write_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write recipe`)
};

const de_import_write_recipe = /** @type {(inputs: Import_Write_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept schreiben`)
};

/**
* | output |
* | --- |
* | "Write recipe" |
*
* @param {Import_Write_RecipeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_write_recipe = /** @type {((inputs?: Import_Write_RecipeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Write_RecipeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_write_recipe(inputs)
	return en_import_write_recipe(inputs)
});